import { RequestStatus } from 'clickNgo/configs/service/common'

import { ICompetitorsSobState } from './models/state'

export const initialState: ICompetitorsSobState = {
  partnerId: '',
  fYear: 0,
  initialData: {},
  data: {},
  competitorsForSelect: {},
  fetchCompetitorsForSelectStatus: RequestStatus.NONE,
  fetchCompetitorsStatus: RequestStatus.NONE,
  savingStatus: RequestStatus.NONE,
  comment: {},
  commentStatus: RequestStatus.NONE,
}
